import React from 'react'
import { Grid } from '@mui/material'
import { InputCantidad, InputCodigo, InputImporte, InputTexto } from '../../comp/Input'
import { InputSelect as SelectCategorias } from './categorias/InputSelect'
import { Traduccion } from '../../comp/Traduccion'
import { ModalDetail } from '../../comp/ModalDetail'
import { Switcher } from '../../comp/Switcher'
import { Acciones } from '../../utils/Acciones'
import { listarCategoriasProducto } from '../../services/servCategoriasProductos'
import { agregarProducto, buscarSiguienteCodigoDisponible, editarProducto } from '../../services/servProductos'
import { Messages } from '../../comp/Messages2'
import { EstadoFormulario } from '../../utils/Constantes'

const defaultFormValues = {categoria:undefined, conDevolucion:false, activo:true}

export const Detalle = ({accion, isOpen, onSubmit, seleccion, verPrecioCompra, verPrecioVenta}) => {

    const [form, setForm] = React.useState(defaultFormValues)
    const [formStatus, setFormStatus] = React.useState(EstadoFormulario.PREPARADO)

    const handleFormChange = (val, field) => setForm({...form, [field]: val})
    const handleCategoriaChange = (val) => {
        setForm({...form, categoria: val ? {id: val} : undefined})
    }

    const [categorias, setCategorias] = React.useState([])
    const [isCategoriasLoading, setIsCategoriasLoading] = React.useState(false)

    const [resServicio, setResServicio] = React.useState()
    
    const esEditable = () => accion !== Acciones().SEE
    const obligatoriosConValor = () => form.codigo && form.nombre && form.precioCosto >= 0 && form.precioVenta >= 0 && form.cantidad >= 0

    const handleSubmit = async (res) => {
        setResServicio() //inicializo los msjs
        if (!res) return onSubmit()
        //si intento enviar form y los obligatorios no están completos interrumpo
        if (!obligatoriosConValor()) return setFormStatus(EstadoFormulario.CON_ERRORES)
        setFormStatus(EstadoFormulario.CARGANDO)
        var aux = {...form}
        const resServ = !aux.id
            ? await agregarProducto(aux)
            : await editarProducto(aux)
        setResServicio(resServ)
        if (resServ.status > 200) return setFormStatus(EstadoFormulario.CON_ERRORES)
        if (!aux.id) aux.id = resServ.data.id
        onSubmit(aux)
    }

    //inicializo todo lo que solo tiene que hacerse una sola vez
    React.useEffect(() => {
        setIsCategoriasLoading(true)
        listarCategoriasProducto({activo:true}).then(d => {
            setCategorias(d.data)
            setIsCategoriasLoading(false)
        })
    }, [])

    React.useEffect(() => {
        if (isOpen) {
            let aux = seleccion ? {...defaultFormValues, ...seleccion} : {...defaultFormValues}
            setForm(aux)
            setFormStatus(EstadoFormulario.PREPARADO)
            if (!aux.codigo) {
                buscarSiguienteCodigoDisponible().then(d => {
                    setForm({...aux, codigo: d.data})
                })
            }
        }
    }, [seleccion, isOpen])

    //inicializo los msjs cada vez que cierro el modal
    React.useEffect(() => {
        if (!isOpen) setResServicio()
    }, [isOpen])
    
    return <>
        <ModalDetail accion={accion} isOpen={isOpen} onSubmit={handleSubmit} isLoading={formStatus === EstadoFormulario.CARGANDO}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <InputCodigo id='codigo'
                                label={Traduccion('TXT_CODIGO')}
                                value={form.codigo}
                                onChange={handleFormChange}
                                digits={18}
                                editable={esEditable()}
                                validarSubmit={formStatus === EstadoFormulario.CON_ERRORES}
                                requerido
                                autoFocus/>
                </Grid>
                <Grid item xs={12}>
                    <InputTexto id='nombre'
                                label={Traduccion('TXT_NOMBRE')}
                                value={form.nombre}
                                onChange={handleFormChange}
                                editable={esEditable()}
                                validarSubmit={formStatus === EstadoFormulario.CON_ERRORES}
                                requerido/>
                </Grid>
                { verPrecioCompra &&
                        <Grid item xs={6}>
                            <InputImporte id='precioCosto'
                                            label={Traduccion('TXT_COSTO_MIN')}
                                            value={form.precioCosto}
                                            onChange={handleFormChange}
                                            editable={esEditable()}
                                            validarSubmit={formStatus === EstadoFormulario.CON_ERRORES}
                                            requerido/>
                        </Grid>
                }
                { verPrecioVenta &&
                        <Grid item xs={6}>
                            <InputImporte id='precioVenta'
                                            label={Traduccion('TXT_VENTA_MIN')}
                                            value={form.precioVenta}
                                            onChange={handleFormChange}
                                            editable={esEditable()}
                                            validarSubmit={formStatus === EstadoFormulario.CON_ERRORES}
                                            requerido/>
                        </Grid>
                }
                <Grid item xs={6}>
                    <InputCantidad id='cantidad'
                                    label={Traduccion('TXT_STOCK')}
                                    value={form.cantidad}
                                    onChange={handleFormChange}
                                    editable={esEditable()}
                                    validarSubmit={formStatus === EstadoFormulario.CON_ERRORES}
                                    requerido/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <SelectCategorias id='categoria'
                                        categoriaId={form.categoria?.id}
                                        listaCategorias={categorias}
                                        isLoading={isCategoriasLoading}
                                        onChange={handleCategoriaChange}
                                        editable={esEditable()}/>
                </Grid>
                <Grid item xs={12}>
                    <Switcher id='conDevolucion'
                                label={Traduccion('TXT_PREGUNTA_ADMITE_DEVOLUCION')}
                                value={form.conDevolucion}
                                onChange={handleFormChange}
                                editable={esEditable()}/>
                </Grid>
            </Grid>
        </ModalDetail>
        <Messages resServicio={resServicio} accion={accion}/>
    </>
}